(ns motorsaif.web.forms.business
  (:require
   [taoensso.encore :as encore]
   [goog.string :refer [format]]
   [motorsaif.i18n :as i18n :refer [tr]]
   [motorsaif.malli :as malli]
   [motorsaif.validation :as validation]
   [motorsaif.log :as log]
   [motorsaif.string :as mstr :refer [format]]
   [reagent.core :as r]
   [motorsaif.web.components :as c]
   [motorsaif.frontend-routes :as routes] ;; ["react-transition-group" :refer [CSSTransition TransitionGroup]]
   [motorsaif.web.lib.form :as form]
   [re-frame.core :as rf :refer [dispatch subscribe]]))

(defn photos [{:keys [uploader uploaded-media  get-val retract-fn]}]
  [:div.form-section
   [:h3 "Photos"]
   [:div#issues
    (let [media-path [:business :business/media]]
      [:div
       [:div.full-upload-wrapper
        [uploaded-media
         {:after-remove
          (fn [{id :db/id :as itm}]
            (log/info [:item itm])
            (let [parent-id (get-val [:business :db/id])]
              (retract-fn {:parent-id parent-id
                           :key :business/media
                           :item-id id})))}
         media-path]
        [uploader media-path]]])]])

(defn services [{:keys [on-save filters start-open?]}]
  (let [*filters (r/atom filters)
        add-new-fn (fn [data]
                     (dispatch [:set-modal nil])
                     (when data
                       (swap! *filters (fnil conj []) data)))
        *added-shown? (r/atom start-open?)
        _ (add-watch *filters :save-watch
                     (fn [_ _ _ new-state]
                       (on-save new-state)))
        show-modal-fn (fn []
                        (dispatch [:assoc-data :modal
                                   {:renderer
                                    (fn [] [c/services-modal {:init-data {}
                                                              :on-save add-new-fn}])}]))]
    (fn []
      (let [filters @*filters]
        [:div.feed-filters
         (if (seq filters)
           [:div.has-filters
            [:div.flex
             #_[:button.btn.primary.show-added
              {:type "button"
               :on-click #(swap! *added-shown? not)}
              [:span.txt
               [:span.count (count filters)]
               (str (mstr/pluralize :word " filter" :count (count filters)) " added")]
              (if @*added-shown?
                [:i.fas.fa-caret-up]
                [:i.fas.fa-caret-down])]

             #_[:button.btn.primary.add-filter
              {:type "button"
               :on-click show-modal-fn}
              [:i.fal.fa-filter-list]
              "Add Service"]]

            (when true
              (into [:div.filter-list]
                    (map-indexed #(c/service-filter
                                   {:idx %1
                                    :data %2
                                    :*filters *filters}) filters)))]

           [:div.no-filters
            [:div.flex
             [:span "All Services"]
             [:button.btn.primary.add-filter
              {:type "button"
               :on-click show-modal-fn}
              [:i.fal.fa-filter-list]
              (tr :general.services "Services")]]])]))))

(defn location [{:keys [set-val radio]}]
  [:div.form-section
   [:h3 "Location"]
   [radio
    (mapv (fn [{id :db/id
                loc-name :location/name}]
            {:title loc-name
             :value id})
          @(subscribe [:locations]))
    {:class "horizontal small"}
    [:business :business/location]]])

(defn role-delete-button
  "Quick hack to show user feedback"
  [{:keys [retract-entity-fn db-id]}]
  (let [*clicked (r/atom false)]
    (fn []
      [:button.role-delete.btn
       {:type "button"
        :disabled @*clicked
        :class (when-not @*clicked "accent")
        :on-click #(do
                     (reset! *clicked true)
                     (retract-entity-fn db-id))}
       (if @*clicked "Marked for deletion"
           [:i.fas.fa-times])])))

(defn user-roles
  [{:keys [set-val get-val select retract-entity-fn] :as form}]
  (let [business-id (get-val [:business :db/id])
        existing-roles (get-val [:business :roles])
        users
        (mapv
         (fn [{id :db/id :user/keys [handle email]}]
           {:title (format "%s - %s" handle email)
            :value id})
         @(subscribe [:admin-data :users]))]
    (fn []
      [:div
       [:h3 "Current Users"]
       (when (seq existing-roles)
         (into [:div.existing-roles]
               (map (fn [{db-id :db/id {:user/keys [email handle]} :role/owner}]
                      [:div.grid.col-2
                       [:div.val
                        [:span handle]
                        [:div email]]
                       [:div.action
                        [role-delete-button {:retract-entity-fn retract-entity-fn
                                             :db-id db-id}]]])
                    existing-roles)))
       [:br]
       [:h3 "Add New User to Business"]
       [:p.selected
        (when-let [user (get-val [:roles :role/owner])]
          [:p "ADDING: " (:title (first (filter #(= (:value %) user) users)))])]
       (let [online-users @(subscribe [:online-users])
             current-user-id (:db/id @(subscribe [:user]))
             online-users (into #{} (map first online-users))
             other (disj online-users current-user-id)]

         (when (seq other)
           [:div.online
            [:p "Online Users"]
            (into [:ul]
                  (map (fn [{:keys [title value]}]
                         [:li
                          title
                          " "
                          [:button.btn.primary.small
                           {:type "button"
                            :on-click #(do
                                         (set-val [:roles :role/target] business-id)
                                         (set-val [:roles :role/level] 0)
                                         (set-val [:roles :role/owner] value))}
                           "Select"]])
                       (filter #(other (:value %)) users)))]))

       ;; (contains? #{1 2} 1)

       [select
        users
        {:label "Select User"
         :placeholder "User"
         :after-change
         (fn [_val]
           (set-val [:roles :role/target] business-id)
           (set-val [:roles :role/level] 0))}
        [:roles :role/owner]]])))

(defn gps-location [{:keys [get-val presentable-error set-val]}]
  (let [path [:business :business/coords]
        default-coords (get-val path)
        on-pos-change (fn [{:keys [geocode lon lat]}]
                        (set-val [:business :business/misc :geo-location] (get-in (js->clj geocode) ["results" 0 "formatted_address"]))
                        (set-val path [lon lat]))

        [lon lat] (or default-coords [55.132 25.069])
        *map (r/atom nil)
        *marker (r/atom nil)
        *jump (r/atom false)

        set-pan (fn [{:keys [lat lng] :as loc}]
                  (reset! *jump false)
                  ^js (.setPosition @*marker (clj->js loc))
                  ^js (.panTo @*map (clj->js loc)))]
    (fn []
      [:div.gps-location
       (when-let [error (presentable-error path)]
         error)
       [c/g-map {:*map *map
                 :*marker *marker
                 :on-pos-change on-pos-change
                 :coords {:lat lat
                          :lng lon}}]
       [:button#jump.btn.primary
        {:on-click #(do
                      (reset! *jump true)
                      (c/get-gps-pos set-pan))
         :type "button"}
        (if @*jump
          (tr :forms.request.gps/locating)
          (tr :forms.request.gps/jump))]])))

(defn location-input [{:keys [get-val set-val presentable-error] :as form-args}]
  (let [*set-mode (r/atom false)]
    (fn []
      (let [path [:business :business/coords]
            default-coords (get-val path)
            on-pos-change (fn [{:keys [geocode lon lat]}]
                            (set-val [:business :business/geo-location] (get-in (js->clj geocode) ["results" 0 "formatted_address"]))
                            (set-val path [lon lat]))
            no-coords [55.132 25.069]]
        [:div
         [:h3 (tr :forms.request.location/title)]
         [:p.helper.italic (tr :forms.request.location/description)]
         (if @*set-mode
           [:div
            [:div.gps-location
             (when-let [error (presentable-error path)]
               error)
             [c/gps-location {:on-pos-change on-pos-change
                              :default-coords default-coords}]]
            [(fn []
               [:div.geo-location
                (or (get-val [:business :business/geo-location])
                    (tr :forms.request.location/drop-pin))])]]
           [:div
            [c/map-image (or default-coords no-coords)]
            [:button.btn.primary.full
             {:type "button"
              :on-click #(reset! *set-mode true)}
             (if default-coords
               "Change GPS Location"
               "Set GPS Location")]])]))))

(let [limiter (encore/rate-limiter {:unique-num-1-per-30s [1 (encore/ms :secs 30)]})
      *limited-fn (atom nil)]
  (defn send-whatsapp-verification
    [{:keys [val *ret]}]
    (let [req {:type :POST
               :url "/api/businesses/whatsapp-send-code"
               :id :username-req
               :params {:phone val}
               :handler (fn [{:keys [success] :as ret}]
                          (reset! *ret ret))
               :error-handler #(reset! *ret {:error %})}
          [_ backoff] (limiter val)
          call-fn #(when @*limited-fn
                     (@*limited-fn)
                     (reset! *limited-fn nil))]
      (reset! *limited-fn #(rf/dispatch [:do-ajax req]))
      (if backoff
        (reset! *ret {:backoff backoff})
        (call-fn)))))

(defn verify-whatsapp [{:keys [input *ret get-val code-entry set-val]}]
  (set-val [:business :business/misc :whatsapp-verified] false)
  (r/create-class
    {:component-will-unmount (fn []
                               (set-val [:business :business/misc] #(dissoc % :whatsapp-verified)))
     :reagent-render
     (fn []
       [:div
        [:button.btn.primary
         {:type "button"
          :on-click #(send-whatsapp-verification
                      {:val (get-val [:business :business/misc :whatsapp])
                       :*ret *ret})}
         "Send Verification Code"]
        (when (:code @*ret)
          [input {:label "Whatsapp Code"
                  :helper "Check your whatsapp"
                  :on-change code-entry}
           [:business :business/misc :whatsapp-verify-code]])])}))

(defn whatsapp [{:keys [ input set-val get-val] :as form-args}]
  (let [init-val (get-val [:business :business/misc :whatsapp])
        *ret (r/atom nil)
        ;; *code-matches? (r/atom nil)
        code-entry (fn [v] (when (= (:code @*ret) v)
                             (set-val [:business :business/misc :whatsapp-verified] true)))]
    (fn []
      (let [val (get-val [:business :business/misc :whatsapp])
            new? (not= init-val val)
            valid? (when (seq val)
                     (:valid (malli/validate validation/uae-whatsapp val)))]
        [:div.whatsapp-verification
         ;; (str [:val val :init init-val :ret @*ret :match (get-val [:business :business/misc :whatsapp-verified])])
         [:div
          [input {:label "Whatsapp"
                  :helper "Whatsapp UAE Number"} [:business :business/misc :whatsapp]]]
         (when (and new? valid?)
           [verify-whatsapp {:input input
                             :set-val set-val
                             :get-val get-val
                             :code-entry code-entry
                             :val val
                             :*ret *ret}])]))))

(defn form [{:keys [make-form-args form-key]}]
  (let [{:keys [*new-data *data input radio form-params set-val get-val init-data] :as form-args}
        (form/make-form make-form-args)
        on-pos-change (fn [{:keys [lon lat]}]
                        (set-val [:business :business/coords] [lon lat]))]
    (fn []
      [:form#profile.default
       form-params
       [:div.fields
        #_[:div
           (str (dissoc @*new-data :uploads))
           ]
        [:section.bordered
         [:div.form-section
          [photos form-args]
          [:br]
          [:h3 "Services"]
          [services
           {:start-open? true
            :on-save (fn [data]
                       (set-val [:business :business/misc :filters] data))
            :filters (get-val [:business :business/misc :filters])}]

          [input {:label "Business Name"} [:business :business/name]]
          [input {:label "Description"
                  :rows 2
                  :type :textarea} [:business :business/description]]
          [input {:label "Working Hours"
                  :rows 2
                  :type :textarea} [:business :business/misc :hours]]

          [input {:label "Email"} [:business :business/email]]
          [input {:label "Phone"} [:business :business/misc :phone]]
          [whatsapp form-args]
          [location-input form-args]]]

        (when @(subscribe [:is-admin?])
          [:section.bordered
           [:h2 "Business Users"]
           (when (= form-key :admin-edit-business)
             [user-roles form-args])])
        [:br]
        [:div.float-save
         [:button.btn.primary-secondary.full
          {:type "submit"}
          (condp = form-key
            :new-business "Create"
            :edit-business "Save"
            :admin-edit-business "Save")]]]])))
